module.exports = function() {
  return new Worker(__webpack_public_path__ + "1ff79b097f68a4ef03f0.worker.js");
};